export const defaultSortConfig = {
  // Extract the original value first, then fallbacks
  valueExtractors: [
    (value) => value?.original,
    (value) => value?.full,
    (value) => value?.short,
    (value) => value,
  ],
  typeDetectors: [
    {
      name: "number",
      detect: (value) => typeof value === "number",
      parse: (value) => value,
      compare: (a, b) => a - b,
    },
    {
      name: "date",
      detect: (value) => {
        // Regex to only treat ISO-like strings as dates
        return (
          typeof value === "string" &&
          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(value)
        );
      },
      parse: (value) => new Date(value),
      compare: (a, b) => a.getTime() - b.getTime(),
    },

    {
      name: "string",
      detect: () => true, 
      parse: (value) => String(value).toLowerCase(),
      compare: (a, b) => a.localeCompare(b),
    },
  ],

  nullHandling: {
    nullsFirst: false,
    bothNull: () => 0,
    oneNull: (isFirstNull) => (isFirstNull ? 1 : -1),
  },
};